import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import NewEditor from './NewEditor';

class Container extends Component {
  render() {
    return (
      <div id="editors">
        <Route exact path="/editors" component={List} />
        <Route exact path="/editors/new" component={NewEditor} />
      </div>
    );
  }
}

export default Container;
